import format from 'date-fns/format'
import isToday from 'date-fns/isToday'
import parseISO from 'date-fns/parseISO'
import numeral from 'numeral'
import pluralize from 'pluralize'

const TIME = `h:mma`
const FULL_DATE = `MMMM do, yyyy`
const FULL_DATE_AND_TIME = `MMMM do, yyyy 'at' h:mma`

export function formatTimeString(date: string) {
  return format(parseISO(date), TIME)
}

export function formatDateString(date: string, pattern?: string) {
  return format(parseISO(date), pattern || 'M/d/yy, h:mm a')
}

export function formatTime(date: Date) {
  return format(date, TIME)
}

export function formatFullDate(date: Date) {
  return format(date, FULL_DATE)
}

export function formatFullDateAndTime(date: Date) {
  return format(date, FULL_DATE_AND_TIME)
}

export function formatFullDateAndTimeString(date: string) {
  return format(parseISO(date), FULL_DATE_AND_TIME)
}

export function formatRelativeDateAndTimeString(date: string) {
  const d = parseISO(date)

  return isToday(d) ? formatTime(d) : formatFullDateAndTime(d)
}

export function formatMoney(money: number) {
  return numeral(money).format('$0.00')
}

const APOSTROPHE_CHAR = "'"

export function formatPossessive(name: string) {
  if (name === '') {
    return name
  }

  const lastChar = name.slice(-1)
  const endOfWord =
    lastChar.toLowerCase() === 's' ? APOSTROPHE_CHAR : `${APOSTROPHE_CHAR}s`
  return `${name}${endOfWord}`
}

export function formatPlural(word: string, count: number) {
  return pluralize(word, count)
}
